/* Farbkacheln im Listing: Das Bild jeder Farbe wird ueber /products/<handle>.js geholt.
   Serverseitig (all_products) liefert Shopify nur fuer rund 20 Produkte pro Seite ein
   richtiges Bild, danach kommt ein falsches. Daher gilt immer das Bild aus dieser Abfrage. */
(function () {
  var style = document.createElement('style');
  style.textContent = 'img[data-live-handle]:not([data-ct-done]){opacity:0}img[data-live-handle]{transition:opacity .2s}';
  document.head.appendChild(style);
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem('color-tile-img') || '{}'); } catch (e) {}
  var pending = {};
  function save() { try { sessionStorage.setItem('color-tile-img', JSON.stringify(cache)); } catch (e) {} }
  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    if (!pending[handle]) {
      pending[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var u = p && p.featured_image;
          if (!u) return null;
          u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=96';
          cache[handle] = u; save(); return u;
        })
        .catch(function () { return null; });
    }
    return pending[handle];
  }
  function done(img) { img.setAttribute('data-ct-done', '1'); }
  var queue = [], active = 0, MAX = 6;
  function pump() {
    while (active < MAX && queue.length) {
      var img = queue.shift(); active++;
      (function (im) {
        load(im.getAttribute('data-live-handle')).then(function (u) {
          if (!u) { done(im); return; }
          im.removeAttribute('srcset');
          im.onload = im.onerror = function () { done(im); };
          im.src = u;
          if (im.complete) done(im);
        }).then(function () { active--; pump(); });
      })(img);
    }
  }
  function scan() {
    document.querySelectorAll('img[data-live-handle]:not([data-ct])').forEach(function (img) {
      img.setAttribute('data-ct', '1');
      queue.push(img);
    });
    pump();
  }
  var queued = false;
  function schedule() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; scan(); }); }
  document.addEventListener('DOMContentLoaded', scan);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
